import $ from 'jquery';
import { modifyState } from '~src/state';
import {
  showSidebarTab,
  hideAllSidebarTabs,
  handleTabImages,
} from '~src/sidebarLegacy';
import editorConfig from '~config/editorConfig';

export const magicFrameChangeFramePhoto = async () => {
  modifyState('sidebarCurrentImagesTag', editorConfig.magicFrameTag);
  modifyState('magicFrameSelectFramePhotoActive', true);
  await handleTabImages();
  const tagId = window.editorConfig.sidebarTags.items.find(
    (tag) => tag.name === editorConfig.magicFrameTag
  );
  $('#select-ricerca-immagini').val(tagId.objectId).trigger('change');
  hideAllSidebarTabs();
  showSidebarTab('immagini');
};
